import { Stack, Typography } from '@mui/material';
import { Fragment } from 'react';

import { GeocodingSearchInput } from '@/components/routing/GeocodingSearchInput';
import { RouteLocationType } from '@/types/RouteLocationType';

export function RoutingForm() {
  return (
    <Fragment>
      <Typography fontWeight={500} mb={1.5}>
        Start und Ziel
      </Typography>
      <form>
        <Stack spacing={1}>
          <GeocodingSearchInput label="Startpunkt wählen" routeLocationType={RouteLocationType.ORIGIN} />
          <GeocodingSearchInput label="Zielpunkt wählen" routeLocationType={RouteLocationType.DESTINATION} />
        </Stack>
      </form>
    </Fragment>
  );
}
